import {useTranslation} from "react-i18next";
import HeadTittle from "../../../../../components/HeadTittle";
import routes from "../../../../../Routes/routes";
import React from "react";
import SupplierFlowDocumentDetail from "../../../Supplier/SubComponents/SupplierDetailsFlows/SupplierFlowDocumentDetail";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierFlowSupplierOrderDetail = () => {
    const { t } = useTranslation();


    return (
        <>
            <HeadTittle name={t('complete_document') }
                        link={routes.suppliers.employees}
            />
            <SupplierFlowDocumentDetail
                disabled={false}
                deleteEmployeeShow={false}
                setDeleteEmployeeShow={false}
                unlinkShow={false}
                setUnlinkShow={false}
                showBtnDeleteDoc={true}
            />
        </>
    )
}
export default SupplierFlowSupplierOrderDetail
